export const STORE_KEY = {
    // USER_INFO: 'cdd638e00095e76c42db80d69dfdec30',
    authInformation: 'cdd638e00095e76c42db80d69dfdec30',

}
